import styles from './Footer.module.scss';

export default function Footer() {
  return (

    <div className={styles.Footer}>Ecommerce created during Wizeline’s Academy React Bootcamp</div>
  );
}
